export const COURSE_CANCELLED_MESSAGE = "Course cancelled successfully.";
export const COURSE_CANCELLED_REFUND_INITIATED_MESSAGE =
  "Course cancelled successfully. Refund has been initiated and is being processed.";

const REFUND_CONFIRMED_TRANSACTION_STATUSES = new Set([
  "REFUND_SUCCESSFUL",
  "REFUNDED"
]);

const REFUND_PENDING_TRANSACTION_STATUSES = new Set([
  "REFUND_PENDING",
  "REFUND_PROCESSING",
  "REFUND_REQUESTED"
]);

export const normalizeOrderStatus = (status, fallback = "UNKNOWN") => {
  const hasStatus = status !== undefined && status !== null && String(status).trim() !== "";
  const value = hasStatus ? status : fallback;
  return String(value ?? fallback).trim().replace(/\s+/g, "_").toUpperCase();
};

const getTransactions = (order = {}) => (
  Array.isArray(order?.transactionList) ? order.transactionList.filter(Boolean) : []
);

export const hasRefundConfirmedTransaction = (order = {}) => (
  getTransactions(order).some((transaction) => (
    REFUND_CONFIRMED_TRANSACTION_STATUSES.has(
      normalizeOrderStatus(transaction?.status || transaction?.currentStatus, "")
    )
  ))
);

export const hasRefundPendingTransaction = (order = {}) => (
  getTransactions(order).some((transaction) => (
    REFUND_PENDING_TRANSACTION_STATUSES.has(
      normalizeOrderStatus(transaction?.status || transaction?.currentStatus, "")
    )
  ))
);

export const getRefundAwareOrderStatus = (order = {}) => {
  const status = normalizeOrderStatus(order?.currentStatus || order?.status, "UNKNOWN");

  if (hasRefundConfirmedTransaction(order)) return "REFUNDED";
  if (status === "REFUND_PENDING" || hasRefundPendingTransaction(order)) return "REFUND_PENDING";

  return status;
};

export const formatRefundAwareStatus = (status) => {
  const normalizedStatus = normalizeOrderStatus(status, "-");

  if (normalizedStatus === "REFUNDED") return "Refunded";
  if (normalizedStatus === "REFUND_PENDING") return "Refund Pending";
  if (normalizedStatus === "PAYMENT_PROCESSING") return "Payment Processing";
  if (normalizedStatus === "PAYMENT_PENDING") return "Payment Pending";

  return normalizedStatus
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const getCourseCancellationSuccessMessage = (orders = []) => {
  const orderList = Array.isArray(orders) ? orders : [orders];
  const hasRefundInitiated = orderList.some((order) => {
    const status = getRefundAwareOrderStatus(order);
    return status === "REFUND_PENDING" || hasRefundPendingTransaction(order);
  });

  return hasRefundInitiated
    ? COURSE_CANCELLED_REFUND_INITIATED_MESSAGE
    : COURSE_CANCELLED_MESSAGE;
};
